export default () => ({
  buyer: [],
  selectedBuyer: null
})



// WEBPACK FOOTER //
// ./src/store/buyer/initialState.js